/**
 * Customizer.js - Premium Customizer & Cart Drawer Logic
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Theme Helper: Format Money
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents);
    const amount = (cents / 100).toFixed(2);
    // Simple detection: default to Euro/USD style formatting
    return `${amount}€`;
  }

  // Cart Drawer State & Elements
  const cartDrawer = document.getElementById('cart-drawer');
  const drawerPanel = document.getElementById('cart-drawer-panel');
  const backdrop = document.getElementById('cart-drawer-backdrop');
  const closeBtn = document.getElementById('btn-close-cart');
  const exploreEmptyBtn = document.getElementById('btn-explore-empty');
  
  // Cart items container & footer totals
  const cartItemsBody = document.getElementById('cart-items-body');
  const cartFooterTotals = document.getElementById('cart-footer-totals');
  const cartBadgeCount = document.getElementById('cart-badge-count');
  
  // Steps elements
  const stepReview = document.getElementById('cart-step-review');
  const stepCheckout = document.getElementById('cart-step-checkout');
  const stepProcessing = document.getElementById('cart-step-processing');
  const stepSuccess = document.getElementById('cart-step-success');

  // Checkout form fields
  const chkFullName = document.getElementById('chk-fullname');
  const chkEmail = document.getElementById('chk-email');
  const chkAddress = document.getElementById('chk-address');
  const chkCity = document.getElementById('chk-city');
  const chkZip = document.getElementById('chk-zip');
  
  // Promo / Coupon inputs
  const chkPromo = document.getElementById('chk-promo');
  const btnApplyPromo = document.getElementById('btn-apply-promo');
  const promoFeedback = document.getElementById('promo-feedback');
  
  // Checkout totals summary display
  const chkSubtotalDisplay = document.getElementById('chk-subtotal-display');
  const chkDiscountRow = document.getElementById('chk-discount-row');
  const chkDiscountLabel = document.getElementById('chk-discount-label');
  const chkDiscountVal = document.getElementById('chk-discount-val');
  const chkTotalDisplay = document.getElementById('chk-total-display');
  
  // Action buttons
  const btnGoToCheckout = document.getElementById('btn-go-to-checkout');
  const btnBackToCart = document.getElementById('btn-back-to-cart');
  const btnSubmitOrder = document.getElementById('btn-submit-order');
  const btnTotalValue = document.getElementById('btn-total-value');
  const successOrderCode = document.getElementById('success-order-code');
  const btnFinalRedirect = document.getElementById('btn-final-redirect');

  // Internal Checkout / Coupon variables
  let cartData = null;
  let appliedCoupon = null;
  let discountPercentage = 0;

  // Coupons Database
  const VALID_COUPONS = {
    'LLAVERO20': 20,
    'LOVE10': 10
  };

  // Cart Drawer Controller
  window.CartDrawer = {
    isOpen: false,

    open: function() {
      this.isOpen = true;
      cartDrawer.style.display = 'flex';
      document.body.style.overflow = 'hidden'; // Lock main scroll
      this.fetchCart();
      this.goToStep('review');
    },

    close: function() {
      this.isOpen = false;
      cartDrawer.style.display = 'none';
      document.body.style.overflow = ''; // Unlock scroll
    },

    goToStep: function(step) {
      // Deactivate all steps
      [stepReview, stepCheckout, stepProcessing, stepSuccess].forEach(el => {
        if (el) el.classList.remove('active');
      });

      // Activate target step
      if (step === 'review') {
        stepReview.classList.add('active');
      } else if (step === 'checkout') {
        stepCheckout.classList.add('active');
        this.updateCheckoutSummary();
      } else if (step === 'processing') {
        stepProcessing.classList.add('active');
      } else if (step === 'success') {
        stepSuccess.classList.add('active');
      }
    },

    fetchCart: function() {
      fetch('/cart.js')
        .then(res => {
          if (!res.ok) throw new Error('Could not fetch cart details');
          return res.json();
        })
        .then(cart => {
          cartData = cart;
          this.renderCart();
        })
        .catch(err => {
          console.error('Error fetching cart:', err);
          cartItemsBody.innerHTML = '<div class="text-center py-8 text-red-600">Error al cargar el portafolio</div>';
        });
    },

    renderCart: function() {
      // Update badge count
      if (cartBadgeCount) {
        cartBadgeCount.innerText = cartData.item_count;
      }
      
      // Update Shopify native bubbles if they exist
      const bubble = document.querySelector('.cart-count-bubble') || document.getElementById('cart-icon-bubble');
      if (bubble) {
        const countSpan = bubble.querySelector('[aria-hidden="true"]') || bubble;
        if (countSpan) countSpan.innerText = cartData.item_count;
        bubble.classList.remove('hidden');
      }

      if (cartData.item_count === 0) {
        // Empty state render
        cartItemsBody.innerHTML = `
          <div class="cart-empty-state">
            <div class="empty-icon-circle">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            </div>
            <h4 class="empty-title">Su portafolio está vacío</h4>
            <p class="empty-description">Explore nuestras piezas de colección y configure un grabado láser personalizado a su gusto.</p>
            <button class="btn-explore-works" id="btn-explore-empty-dynamic">Explorar Obras</button>
          </div>
        `;
        if (cartFooterTotals) {
          cartFooterTotals.style.display = 'none';
        }
        
        // Listen to dynamic explore button
        const expBtn = document.getElementById('btn-explore-empty-dynamic');
        if (expBtn) {
          expBtn.addEventListener('click', () => {
            this.close();
            const collectionSection = document.getElementById('coleccion');
            if (collectionSection) {
              collectionSection.scrollIntoView({ behavior: 'smooth' });
            }
          });
        }
        return;
      }

      // Render items
      let html = '<div class="cart-items-list">';
      cartData.items.forEach(item => {
        // Build properties layout
        let propertiesHtml = '';
        let hasProperties = false;
        
        if (item.properties) {
          Object.keys(item.properties).forEach(key => {
            const val = item.properties[key];
            if (val && key.indexOf('_') !== 0) {
              hasProperties = true;
              propertiesHtml += `
                <div class="item-engraving-badge">
                  <svg class="sparkle-bullet" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m0-12.728l.707.707m11.314 11.314l.707.707M12 5a7 7 0 100 14 7 7 0 000-14z"/></svg>
                  <span>${key}: "${val}"</span>
                </div>
              `;
            }
          });
        }

        if (!hasProperties) {
          propertiesHtml = '<span class="item-standard-label">Modelo Estándar</span>';
        }

        html += `
          <div class="cart-item-row" data-key="${item.key}">
            <div class="item-img-col">
              <img src="${item.image}" alt="${item.product_title}" loading="lazy">
            </div>
            <div class="item-meta-col flex-grow">
              <h4 class="item-title">${item.product_title}</h4>
              ${propertiesHtml}
              <div class="item-price-qty-row flex justify-between align-center">
                <span class="item-price">${formatMoney(item.final_line_price)}</span>
                <div class="qty-selector flex align-center">
                  <button class="qty-btn btn-minus" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
                  <span class="qty-num">${item.quantity}</span>
                  <button class="qty-btn btn-plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                </div>
              </div>
            </div>
            <button class="item-remove-btn" data-key="${item.key}" aria-label="Eliminar">✕</button>
          </div>
        `;
      });
      html += '</div>';
      
      cartItemsBody.innerHTML = html;

      // Update footer totals
      if (cartFooterTotals) {
        cartFooterTotals.style.display = 'block';
        const subtotalVal = document.getElementById('cart-subtotal-val');
        const totalVal = document.getElementById('cart-total-val');
        
        if (subtotalVal) subtotalVal.innerText = formatMoney(cartData.total_price);
        if (totalVal) totalVal.innerText = formatMoney(cartData.total_price);
      }

      // Re-attach listeners for quantity modifications
      this.attachItemsEvents();
    },

    attachItemsEvents: function() {
      // Plus buttons
      const plusBtns = cartItemsBody.querySelectorAll('.qty-btn.btn-plus');
      plusBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const key = btn.getAttribute('data-key');
          const qty = parseInt(btn.getAttribute('data-qty'));
          this.updateQuantity(key, qty);
        });
      });

      // Minus buttons
      const minusBtns = cartItemsBody.querySelectorAll('.qty-btn.btn-minus');
      minusBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const key = btn.getAttribute('data-key');
          const qty = parseInt(btn.getAttribute('data-qty'));
          if (qty > 0) {
            this.updateQuantity(key, qty);
          } else {
            this.removeItem(key);
          }
        });
      });

      // Remove buttons
      const removeBtns = cartItemsBody.querySelectorAll('.item-remove-btn');
      removeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const key = btn.getAttribute('data-key');
          this.removeItem(key);
        });
      });
    },

    updateQuantity: function(key, qty) {
      this.showLoadingState();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(res => {
        if (!res.ok) throw new Error('Error changing quantity');
        return res.json();
      })
      .then(cart => {
        cartData = cart;
        this.renderCart();
      })
      .catch(err => {
        console.error('Error changing quantity:', err);
        this.fetchCart();
      });
    },

    removeItem: function(key) {
      this.updateQuantity(key, 0);
    },

    showLoadingState: function() {
      cartItemsBody.innerHTML = `
        <div class="flex justify-center items-center py-16 flex-col gap-4">
          <div class="processing-spinner"></div>
          <span class="font-work text-xs text-outline font-semibold tracking-wider uppercase">Actualizando Bolsa...</span>
        </div>
      `;
    },

    // Step 2 checkout calculations
    updateCheckoutSummary: function() {
      if (!cartData) return;

      const subtotalCents = cartData.total_price;
      let discountCents = 0;

      if (appliedCoupon && discountPercentage > 0) {
        discountCents = Math.round(subtotalCents * (discountPercentage / 100));
        
        // Show discount block
        chkDiscountRow.style.display = 'flex';
        chkDiscountLabel.innerText = `${discountPercentage}%`;
        chkDiscountVal.innerText = `-${formatMoney(discountCents)}`;
      } else {
        chkDiscountRow.style.display = 'none';
      }

      const totalCents = Math.max(0, subtotalCents - discountCents);
      
      chkSubtotalDisplay.innerText = formatMoney(subtotalCents);
      chkTotalDisplay.innerText = formatMoney(totalCents);
      
      if (btnTotalValue) {
        btnTotalValue.innerText = formatMoney(totalCents);
      }
    },

    applyPromoCode: function(code) {
      code = code.trim().toUpperCase();
      if (!code) {
        promoFeedback.className = 'promo-feedback-msg error';
        promoFeedback.innerText = 'Por favor, escriba un código';
        promoFeedback.style.display = 'block';
        return;
      }

      const discount = VALID_COUPONS[code];
      if (discount !== undefined) {
        appliedCoupon = code;
        discountPercentage = discount;
        
        promoFeedback.className = 'promo-feedback-msg success';
        promoFeedback.innerText = `¡Cupón ${code} aplicado! Descuento del ${discount}%`;
        promoFeedback.style.display = 'block';
        
        this.updateCheckoutSummary();
      } else {
        appliedCoupon = null;
        discountPercentage = 0;
        
        promoFeedback.className = 'promo-feedback-msg error';
        promoFeedback.innerText = 'El código ingresado no es válido';
        promoFeedback.style.display = 'block';
        
        this.updateCheckoutSummary();
      }
    },

    submitOrder: function() {
      // Validate shipping address
      if (!chkFullName.value.trim() || !chkEmail.value.trim() || !chkAddress.value.trim() || !chkCity.value.trim() || !chkZip.value.trim()) {
        alert('Por favor complete todos los campos de envío obligatorios.');
        return;
      }

      // 1. Move to processing step
      this.goToStep('processing');

      // 2. Simulate transaction duration
      setTimeout(() => {
        // Form random order code
        const randomNum = Math.floor(10000 + Math.random() * 90000);
        const orderCode = `#LL-${randomNum}`;
        successOrderCode.innerText = orderCode;
        
        // 3. Move to Success step
        this.goToStep('success');
      }, 2500);
    },

    finalRedirect: function() {
      let checkoutUrl = '/checkout';
      
      // Pass discount parameter to Shopify checkout page if coupon applied
      if (appliedCoupon) {
        checkoutUrl += `?discount=${appliedCoupon}`;
      }
      
      // Redirect
      window.location.href = checkoutUrl;
    }
  };

  // Open triggers mapping (attach to icons or buttons in header)
  const openTriggers = document.querySelectorAll('[data-cart-drawer-trigger]') || [];
  openTriggers.forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      window.CartDrawer.open();
    });
  });

  // Native Shopify Cart bubble selector fallback
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (cartIconBubble) {
    cartIconBubble.removeAttribute('href'); // override default page redirect
    cartIconBubble.style.cursor = 'pointer';
    cartIconBubble.addEventListener('click', function(e) {
      e.preventDefault();
      window.CartDrawer.open();
    });
  }

  // Bind close buttons
  if (closeBtn) closeBtn.addEventListener('click', () => window.CartDrawer.close());
  if (backdrop) backdrop.addEventListener('click', () => window.CartDrawer.close());

  // Bind explore button inside static drawer
  if (exploreEmptyBtn) {
    exploreEmptyBtn.addEventListener('click', () => {
      window.CartDrawer.close();
      const collectionSection = document.getElementById('coleccion');
      if (collectionSection) {
        collectionSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Bind navigation buttons inside Drawer Steps
  if (btnGoToCheckout) {
    btnGoToCheckout.addEventListener('click', () => {
      window.CartDrawer.goToStep('checkout');
    });
  }

  if (btnBackToCart) {
    btnBackToCart.addEventListener('click', () => {
      window.CartDrawer.goToStep('review');
    });
  }

  // Coupon apply click listener
  if (btnApplyPromo) {
    btnApplyPromo.addEventListener('click', () => {
      window.CartDrawer.applyPromoCode(chkPromo.value);
    });
  }

  // Submit order simulation
  if (btnSubmitOrder) {
    btnSubmitOrder.addEventListener('click', () => {
      window.CartDrawer.submitOrder();
    });
  }

  // Final Redirection click listener
  if (btnFinalRedirect) {
    btnFinalRedirect.addEventListener('click', () => {
      window.CartDrawer.finalRedirect();
    });
  }

  // Listen to product page 'Añadir al carrito' requests to open the custom drawer
  document.addEventListener('cart:item-added', function() {
    window.CartDrawer.open();
  });
  
  // Custom global cart drawer refresh helper
  window.refreshCartDrawer = function() {
    window.CartDrawer.open();
  };

  // ============================================================
  // Wishlist & Favorites Drawer Controller
  // ============================================================
  const favoritesDrawer = document.getElementById('favorites-drawer');
  const favoritesPanel = document.getElementById('favorites-drawer-panel');
  const favoritesBackdrop = document.getElementById('favorites-drawer-backdrop');
  const closeFavoritesBtn = document.getElementById('btn-close-favorites');
  const exploreFavoritesBtn = document.getElementById('btn-explore-favorites');
  const favoritesBadgeCount = document.getElementById('favorites-badge-count');
  const headerFavoritesCount = document.getElementById('header-favorites-count');
  
  const favoritesEmptyState = document.getElementById('favorites-empty-state');
  const favoritesListContainer = document.getElementById('favorites-list-container');
  
  // Storage key
  const FAV_STORAGE_KEY = 'velvet_favorites';
  
  window.FavoritesDrawer = {
    isOpen: false,
    
    getFavorites: function() {
      try {
        const favs = localStorage.getItem(FAV_STORAGE_KEY);
        return favs ? JSON.parse(favs) : [];
      } catch (e) {
        console.error('Error reading favorites', e);
        return [];
      }
    },
    
    saveFavorites: function(favs) {
      try {
        localStorage.setItem(FAV_STORAGE_KEY, JSON.stringify(favs));
        this.updateBadges();
        this.updateCardButtons();
      } catch (e) {
        console.error('Error saving favorites', e);
      }
    },
    
    toggleFavorite: function(product) {
      let favs = this.getFavorites();
      const index = favs.findIndex(f => f.id === product.id);
      
      if (index > -1) {
        favs.splice(index, 1);
        console.log('Removed from favorites:', product.title);
      } else {
        favs.push(product);
        console.log('Added to favorites:', product.title);
      }
      this.saveFavorites(favs);
      if (this.isOpen) {
        this.renderFavorites();
      }
    },
    
    updateBadges: function() {
      const favs = this.getFavorites();
      const count = favs.length;
      
      if (favoritesBadgeCount) favoritesBadgeCount.innerText = count;
      if (headerFavoritesCount) {
        headerFavoritesCount.innerText = count;
        headerFavoritesCount.style.display = count > 0 ? 'flex' : 'none';
      }
    },
    
    updateCardButtons: function() {
      const favs = this.getFavorites();
      const favIds = favs.map(f => f.id);
      
      const wishlistBtns = document.querySelectorAll('.btn-wishlist-toggle');
      wishlistBtns.forEach(btn => {
        const id = btn.getAttribute('data-wishlist-id');
        if (favIds.includes(id)) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    },
    
    open: function() {
      this.isOpen = true;
      favoritesDrawer.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      this.renderFavorites();
    },
    
    close: function() {
      this.isOpen = false;
      favoritesDrawer.style.display = 'none';
      document.body.style.overflow = '';
    },
    
    renderFavorites: function() {
      const favs = this.getFavorites();
      if (favs.length === 0) {
        favoritesEmptyState.style.display = 'block';
        favoritesListContainer.style.display = 'none';
        favoritesListContainer.innerHTML = '';
        return;
      }
      
      favoritesEmptyState.style.display = 'none';
      favoritesListContainer.style.display = 'flex';
      
      let html = '';
      favs.forEach(item => {
        html += `
          <div class="fav-item-row" data-id="${item.id}">
            <div class="fav-item-info">
              <img class="fav-item-img" src="${item.image}" alt="${item.title}">
              <div class="fav-item-meta">
                <h4 class="fav-item-title">${item.title}</h4>
                <span class="fav-item-price">${item.price}</span>
              </div>
            </div>
            <div class="fav-item-actions">
              <a href="/products/${item.handle}" class="btn-fav-configure" title="Configurar / Comprar">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              </a>
              <button class="btn-fav-remove" data-id="${item.id}" title="Eliminar de favoritos">✕</button>
            </div>
          </div>
        `;
      });
      favoritesListContainer.innerHTML = html;
      this.attachEvents();
    },
    
    attachEvents: function() {
      const removeBtns = favoritesListContainer.querySelectorAll('.btn-fav-remove');
      removeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const id = btn.getAttribute('data-id');
          let favs = this.getFavorites();
          favs = favs.filter(f => f.id !== id);
          this.saveFavorites(favs);
          this.renderFavorites();
        });
      });
    }
  };

  // Bind Header favorites click
  const openFavoritesBtn = document.getElementById('header-btn-favorites');
  if (openFavoritesBtn) {
    openFavoritesBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.FavoritesDrawer.open();
    });
  }
  
  if (closeFavoritesBtn) closeFavoritesBtn.addEventListener('click', () => window.FavoritesDrawer.close());
  if (favoritesBackdrop) favoritesBackdrop.addEventListener('click', () => window.FavoritesDrawer.close());
  
  if (exploreFavoritesBtn) {
    exploreFavoritesBtn.addEventListener('click', () => {
      window.FavoritesDrawer.close();
      const collectionSection = document.getElementById('coleccion');
      if (collectionSection) {
        collectionSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Bind wishlist toggle buttons on cards
  function bindWishlistCardButtons() {
    const wishlistBtns = document.querySelectorAll('.btn-wishlist-toggle');
    wishlistBtns.forEach(btn => {
      // Avoid duplicate binding
      if (btn.getAttribute('data-bound') === 'true') return;
      btn.setAttribute('data-bound', 'true');
      
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const id = btn.getAttribute('data-wishlist-id');
        const title = btn.getAttribute('data-wishlist-title');
        const price = btn.getAttribute('data-wishlist-price');
        const image = btn.getAttribute('data-wishlist-image');
        const variantId = btn.getAttribute('data-wishlist-variant-id');
        const handle = btn.getAttribute('data-wishlist-handle');
        
        const product = { id, title, price, image, variantId, handle };
        window.FavoritesDrawer.toggleFavorite(product);
      });
    });
  }

  // Run initialization
  window.FavoritesDrawer.updateBadges();
  window.FavoritesDrawer.updateCardButtons();
  bindWishlistCardButtons();
  
  // Re-bind if dynamic lists update (e.g. filters)
  document.addEventListener('wishlist:refresh-bindings', bindWishlistCardButtons);

  // Mobile bottom navigation event listeners
  const mobileBtnFav = document.getElementById('mobile-btn-favorites');
  if (mobileBtnFav) {
    mobileBtnFav.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.FavoritesDrawer) {
        window.FavoritesDrawer.open();
      }
    });
  }

  const mobileBtnCart = document.getElementById('mobile-btn-cart');
  if (mobileBtnCart) {
    mobileBtnCart.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.CartDrawer) {
        window.CartDrawer.open();
      }
    });
  }

});
